import styled from '@emotion/styled';
import {
	ContentWrap,
	Css,
	ITheme,
	IUrlLinkItem,
	Responsive,
} from '../../../ui';
import { ISocialLinksProps, SocialLinks } from '../social-links/SocialLinks';
import { FooterFeaturedLink } from './FooterFeaturedLink';

interface IFooterSocialsSection {
	socialLinks: ISocialLinksProps;
	featuredLink?: IUrlLinkItem;
}

export default function FooterSocialsSection({
	socialLinks,
	featuredLink,
}: IFooterSocialsSection) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');

	// Featured link should always render below the social media icons, even when the parent reverses the children
	const socials = (
		<SocialsWrap hasFeaturedLink={Boolean(featuredLink)}>
			<SocialLinks {...socialLinks} />
			{featuredLink && <FooterFeaturedLink link={featuredLink} />}
		</SocialsWrap>
	);

	return !isMobileXL ? <ContentWrap>{socials}</ContentWrap> : socials;
}

const SocialsWrap = styled.div<{ hasFeaturedLink: boolean }, ITheme>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		/* The social icons carry their own bottom margin on mobile, which
		   already provides the spacing towards the featured link. */
		gap: 0;

		${({ hasFeaturedLink }) =>
			hasFeaturedLink && `margin-bottom: ${Css.pxToRem(24)};`}
	}
`;
